class Menu{

    constructor(){

        $ = jQuery;
        let $menu = $( '#menu-header-menu' );

        //Mobile menu Listener
        $(document).on('click', '#mobile-menu-trigger', function(){
            $menu.fadeToggle();
            $(this).toggleClass( 'fa-bars' ).toggleClass( 'fa-times' );
        });

    }

}

jQuery(document).ready( () => new Menu() );